const internalSiteData = (state = [], action) => {
    switch(action.type) {
        case 'internalSiteData':
            return action.payload;
        default:
            return state;
    }
}

export default internalSiteData;